import React, { createContext, useState, useEffect, useContext } from 'react';
import { isAuthenticated, getCurrentUser } from '../services/authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

    useEffect(() => {
       
        if (isAuthenticated()) {
            const user = getCurrentUser();
            setCurrentUser(user);
        }
        setLoading(false);
    }, []);

  const updateUser = (user) => {
    setCurrentUser(user);
  };

  return (
    <AuthContext.Provider value={{ currentUser, updateUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);